import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject, OnInit, effect } from '@angular/core';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';
import { PaylasKutusuComponent } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/paylas-kutusu/paylas-kutusu.component';
import { FikoYTKartKokComponent } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/fikoyt-kart-kok/fikoyt-kart.component';
import { HmiUretimService } from '../../hmi-uretim.service';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FikoYTIstekSayfalama, ISayfalama } from '@/src/service/modules/fikoyt-istek-kok/fikoyt-istek-sayfalama';
import { IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { CanliGuncellemeService } from '@/src/service/fikoyt-ui/src/lib/dinamik-bilesen/canli-guncelleme.service';
import { FikoFilitreciComponent } from '@service/fikoyt-ui/src/lib/fiko-filitreci/fiko-filitreci.component';
import { IGrupI } from '@service/fikoyt-ui/interfaces/IGrup';
import { IAlanI } from '@service/fikoyt-ui/interfaces/IAlan';
import { DinamikBilesenRegistry } from '@service/fikoyt-ui/src/lib/dinamik-bilesen/dinamik-bilesen.registry';
import { parametredenSiralamaOlustur, IDinamikBilesenFiltreSet } from '@service/fikoyt-ui/src/lib/fiko-filitreci/parametre-filitre-yardimci';

const UYG = 'FikoYT.sistem.hmi.uretim';

@Component({
  selector: 'hmi-uretim-ana-sayfa',
  standalone: true,
  imports: [RouterModule, PaylasKutusuComponent, FikoYTKartKokComponent, NzDividerModule, NzSpinModule, NzButtonModule, NzIconModule, FormsModule, FikoFilitreciComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './ana-sayfa.component.html',
  styleUrl: './ana-sayfa.component.less',
})
export class HmiUretimAnaSayfaComponent extends FikoYTKokBilesenComponent implements OnInit {
  hmiSvc = inject(HmiUretimService);
  private canliGuncelleme = inject(CanliGuncellemeService);
  listeIstek: FikoYTIstekSayfalama;

  constructor() {
    super();
    const kart = this.hmiSvc.kart;
    if (!kart.uygulama) kart.uygulama = [];
    if (!kart.uygulama.includes(UYG)) kart.uygulama.push(UYG);

    this.listeIstek = new FikoYTIstekSayfalama({
      metod: 'POST',
      komut: 'FikoYT.sistem.DB.hareketler.aggregate',
      onEkOlsun: true,
      filitreler: [
        {
          $match: {
            vt: 'FikoYT.sistem.hareketler' as IVT,
            yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
            uygulama: UYG,
          }
        },
        {
          $match: { silindi: { $ne: true } }
        },
        {
          $lookup: {
            from: 'hareketler',
            localField: 'veri.icerikler',
            foreignField: '_id',
            as: 'veri.icerikler',
          }
        },
      ],
      sayfalama: { sayi: 10, siralama: { _id: -1 } } as ISayfalama,
      depoModu: false, oncelik: 0, gecikmeliCevap: false, gecikmeliCevapSuresi: 0,
      otoSonId: true, eklemeliListe: false,
    })
      .onMesgulDegisti(() => { setTimeout(() => this.CD.detectChanges()); })
      .onTamamlandi(() => { setTimeout(() => this.CD.detectChanges()); });

    effect(() => {
      const g = this.canliGuncelleme.kartGuncellendi();
      if (!g) return;
      const idx = this.listeIstek.liste.findIndex(k => k._id === g.kartId);
      if (idx >= 0) { this.listeIstek.liste[idx] = { ...this.listeIstek.liste[idx], ...g.veri }; this.listeIstek.liste = this.listeIstek.liste.slice(); this.CD.detectChanges(); }
    });
    effect(() => {
      const id = this.canliGuncelleme.kartSilindi();
      if (!id) return;
      this.listeIstek.liste = this.listeIstek.liste.filter(k => k._id !== id);
      this.CD.detectChanges();
    });
    effect(() => {
      const kart = this.canliGuncelleme.kartYeni();
      if (!kart) return;
      this.listeIstek.liste = [kart, ...this.listeIstek.liste];
      this.CD.detectChanges();
    });
  }

  ngOnInit() {
    this.listeIstek.isteSync();
    this.subsList.push(
      this.FikoYT.degisti.subscribe(() => {
        setTimeout(() => this.listeIstek.isteSync(), 500);
      })
    );
  }

  geriTiklandi() {
    const icerikler = this.hmiSvc.kart?.veri?.icerikler;
    const aktifIcerik = icerikler?.[this.hmiSvc.aktifIcerikNo];
    if (aktifIcerik?.ek?.parametreler?.length > 0 || aktifIcerik?.ek?._secilenSetId) {
      aktifIcerik.ek = null;
      this.CD.detectChanges();
      return;
    }
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  paylasimYapildi() {
    this.hmiSvc.sifirla();
    const kart = this.hmiSvc.kart;
    if (!kart.uygulama) kart.uygulama = [];
    if (!kart.uygulama.includes(UYG)) kart.uygulama.push(UYG);
    this.listeIstek.isteSync();
  }

  filitreciAcik = false;
  filitreciSablon: IGrupI = { veVeya: 've', acik: true, alanlar: [] };

  temelSiralamalar = [
    { ismi: '📅 En Yeni', degeri: { tarih: -1 } },
    { ismi: '📅 En Eski', degeri: { tarih: 1 } },
    { ismi: '✏️ Son Düzenlenen', degeri: { duzenlenmeTarihi: -1 } },
    { ismi: '✏️ İlk Düzenlenen', degeri: { duzenlenmeTarihi: 1 } },
  ];
  aktifSiralama: any = { tarih: -1 };

  get siralamalar() {
    return [...this.temelSiralamalar, ...parametredenSiralamaOlustur(this.tumParametreler)];
  }

  siralamaDegisti(deger: any) {
    this.aktifSiralama = deger;
    this.listeIstek.sayfalama.siralama = deger;
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
  }

  get bilesenTipleri() {
    return (this.hmiSvc?.parametreSetleri || [])
      .filter(g => g.bilesen)
      .map(g => ({ id: g.bilesen!, baslik: g.baslik, renk: g.renk, simge: g.simge }));
  }

  get tumParametreler() {
    return (this.hmiSvc?.parametreSetleri || [])
      .flatMap(g => g.parametreler || [])
      .filter((p, i, arr) => arr.findIndex(x => x.ismi === p.ismi) === i);
  }

  get dinamikBilesenSetleri(): IDinamikBilesenFiltreSet[] {
    const sonuc: IDinamikBilesenFiltreSet[] = [];
    const gorulenler = new Set<string>();
    const tara = (gruplar: any[]) => {
      for (const g of gruplar) {
        if (g.bilesen && !gorulenler.has(g.bilesen)) {
          gorulenler.add(g.bilesen);
          const parametreler = [...(g.parametreler || []), ...(g.altGruplar?.flatMap((ag: any) => ag.parametreler || []) || [])];
          if (parametreler.length > 0) sonuc.push({ id: g.bilesen, setId: g.id, baslik: g.baslik, simge: g.simge, parametreler });
        }
        if (g.altGruplar?.length) tara(g.altGruplar);
        if (g.altKartSablonlari?.length) tara(g.altKartSablonlari);
      }
    };
    tara(this.hmiSvc?.parametreSetleri || []);
    return sonuc;
  }

  get hesapAlanlari(): IAlanI[] {
    const alanlar: IAlanI[] = [];
    for (const kayit of DinamikBilesenRegistry.tumKayitlar()) {
      const prepipe = (kayit.tanim as any)?.hesaplamalar?.prepipe;
      if (!prepipe?.length) continue;
      for (const stage of prepipe) {
        if (!stage?.$addFields) continue;
        for (const [key, _] of Object.entries(stage.$addFields)) {
          if (!key.startsWith('_hesap.')) continue;
          const baslik = key.replace('_hesap.', '').replace(/([A-Z])/g, ' $1').trim();
          alanlar.push({
            ismi: key, baslik, tipi: 'Sayı Kutusu', prepipeAlani: key,
            esitlikTurleri: ['=', '!=', '<', '>', '>=', '<='],
            aktifEsitlikTuru: '>',
            aciklama: baslik,
          });
        }
      }
    }
    return alanlar;
  }

  private prepipeStemleriAl(): any[] {
    if (!FikoFilitreciComponent.sablondaPrepipeVarMi(this.filitreciSablon)) return [];
    const prepipeSet: any[] = [];
    for (const kayit of DinamikBilesenRegistry.tumKayitlar()) {
      const prepipe = (kayit.tanim as any)?.hesaplamalar?.prepipe;
      if (prepipe?.length) { prepipeSet.push(...prepipe); break; }
    }
    return prepipeSet;
  }

  filtreUygula() {
    const mongoSorgu = FikoFilitreciComponent.toMongoFromSablon(this.filitreciSablon) || {};
    const match = (mongoSorgu && Object.keys(mongoSorgu).length) ? mongoSorgu : {};
    const prepipeStages = this.prepipeStemleriAl();
    this.listeIstek.filitreler[3] = prepipeStages.length ? prepipeStages : null;
    this.listeIstek.filitreler[4] = { $match: match };
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
  }

  filtreTemizle() {
    this.filitreciSablon = { veVeya: 've', acik: true, alanlar: [] };
    this.listeIstek.filitreler[3] = null;
    this.listeIstek.filitreler[4] = { $match: {} };
    this.listeIstek.parametreler.aggregate = this.listeIstek._alAggregate();
    this.listeIstek.isteSync();
  }
}
